import React from 'react';
import { NoteName, Note } from '../models/Note';
import { Piano } from './Piano';
import { ChordNames } from './ChordNames';
import Audio from '../audio';

interface AppProps {}
interface AppState {
  selectedNotes: Note[];
  isPlaying: boolean;
}

export default class App extends React.Component<AppProps, AppState> {
  constructor(props: AppProps) {
    super(props);

    this.state = {
      selectedNotes: [],
      isPlaying: false,
    };

    this.updateSelection = this.updateSelection.bind(this);
    this.toggleSelection = this.toggleSelection.bind(this);
    this.selectNotes = this.selectNotes.bind(this);
    this.playSound = this.playSound.bind(this);
    this.stopSound = this.stopSound.bind(this);

    (window as any).selectNotes = this.selectNotes;

    this.audio = new Audio();
    window.addEventListener('hashchange', this.updateSelection);
    setTimeout(() => this.updateSelection());
  }

  audio: Audio;

  updateSelection() {
    const selectedNotes = getSelectionFromUrl();
    this.setState({ selectedNotes });
    if (this.state.isPlaying) {
      this.audio.play(selectedNotes);
    }
  }

  playSound() {
    this.setState({ isPlaying: true });
    this.audio.play(this.state.selectedNotes);
  }

  stopSound() {
    this.setState({ isPlaying: false });
    this.audio.play([]);
  }

  toggleSelection(note: Note) {
    const selectedNotes = [...this.state.selectedNotes];
    const noteIndex = selectedNotes.indexOf(note);
    if (noteIndex === -1) {
      selectedNotes.push(note);
    } else {
      selectedNotes.splice(noteIndex, 1);
    }
    setUrlToSelection(selectedNotes);
  }

  selectNotes(noteNames?: NoteName[]) {
    let selectedNotes: Note[];
    if (noteNames == null) {
      selectedNotes = randomNotes();
    } else {
      selectedNotes = noteNames.map(n => Note[n]);
    }
    setUrlToSelection(selectedNotes);
  }

  renderButtons() {
    const { isPlaying } = this.state;

    return (
      <div className="button-wrapper">
        <button
          title="clear"
          className="clear-button"
          onClick={() => this.selectNotes([])}
        >
          ✘
        </button>
        <button
          title="random"
          className="random-button"
          onClick={() => this.selectNotes()}
        >
          ❓
        </button>
        <button
          title={isPlaying ? 'stop' : 'play'}
          className="play-button"
          onClick={isPlaying ? this.stopSound : this.playSound}
        >
          {isPlaying ? '■' : '▶'}
        </button>
      </div>
    );
  }

  render() {
    const { selectedNotes } = this.state;

    console.log(selectedNotes.map(n => Note[n]));

    return (
      <div className="App">
        <h1>ChordNames</h1>
        <div>
          <Piano
            selectedNotes={selectedNotes}
            toggleSelection={this.toggleSelection}
          />
        </div>
        {this.renderButtons()}
        <div>
          <ChordNames selectedNotes={selectedNotes} />
        </div>
      </div>
    );
  }
}

function getSelectionFromUrl(): Note[] {
  const hash = window.location.hash.match(/\d+/);
  return hash != null ? decodeNotes(parseInt(hash[0])) : [];
}

function setUrlToSelection(selectedNotes: Note[]) {
  const hash = encodeNotes(selectedNotes).toString();
  window.history.replaceState(null, '', '#' + hash);
  window.dispatchEvent(new HashChangeEvent('hashchange'));
}

function randomNotes(): Note[] {
  return decodeNotes(Math.floor(Math.random() * Math.pow(2, 12)));
}

function decodeNotes(i: number): Note[] {
  const bits = Array.from(i.toString(2).padStart(12, '0'));
  const notes: Note[] = [];

  bits.forEach((bit, i) => {
    if (bit === '1') notes.push(i);
  });

  return notes;
}

function encodeNotes(notes: Note[]): number {
  const bits = new Array(12).fill(0);

  notes.forEach(note => {
    bits[note] = 1;
  });

  return parseInt(bits.join(''), 2);
}
